import RepaymentSuccessScreen from 'features/advance/screens/advanceStatusScreens/PaymentResult/RepaymentSuccessScreen';
import React from 'react';

const RepaymentSuccessPage = () => {
  return <RepaymentSuccessScreen />;
};

export default RepaymentSuccessPage;
